export default __webpack_public_path__ + "static/media/favicon.dc78606d.ico";